/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from 'react';
import { Container, Row, Col, } from 'reactstrap';
import Footer from '../footer';
import QuizFooter from './quiz-footer';
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import { EslidesEvent, Presentation } from '../../types/presentation';
import SocketClient from '../../helpers/connection';
import axios, { AxiosResponse } from "axios";
import EventContext from "../../contexts/event";
import {useSubscription} from "@apollo/client";
import {quiz_actions, quiz_users} from "../../gql/quiz-gql";
import  {Socket} from "socket.io-client";
import {useIntl} from "react-intl";
import {Link} from "react-router-dom";
import QRCode from "react-qr-code";

// quiz live home screen for listing user in speaker mode
const QuizHome: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent; screenMode?: boolean,client:Socket }> = ({ locale, setLocale, ppt, event, screenMode = false ,client}) => {

  const [users, setUsers] = useState<string[]>([]);
  const [code, setCode] = useState("000000");
  const eventContext = useContext(EventContext);
  const slug = document.location.pathname.split("/")[1] || "invalid";
  let token: any = localStorage.getItem(`token-${slug}`);
  const intl = useIntl();

  const { data: quizUsersData } = useSubscription(quiz_users, {
    variables: { presentation_id: ppt._id },
    skip: !ppt?._id,
  });


  // socket connecting to quiz using presentation id
  useEffect(()=>{
    client.emit('join', {presentationId:ppt._id}, (response:any) => {
      console.log("join",response); // ok
    });
  },[])


  useEffect(() => {
    // API CALL : for getting the quiz event code for login purpose
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-code`,
      data: {
        _id: ppt._id,
      },
    }).then((res) => {
      try {
        if (res.data.statusCode === 200) {
          setCode(res.data.code)
        }
      } catch (e) {

      }
       console.log("QUIZ LOGIN", res);

    });
    localStorage.setItem(`answered_users`, '0');

    console.log("eventContext.presentationsWithQuestions",eventContext.presentationsWithQuestions)

  }, []);

  // sync connected users from Hasura (includes users who joined before this page loaded)
  useEffect(() => {
    const quizUsers = quizUsersData?.quiz_users;
    if (!quizUsers) return;
    const names = quizUsers.map((u: { name: string }) => u.name).filter(Boolean);
    setUsers(names);
  }, [quizUsersData]);

  // initialize connected_users cache data
  useEffect(() => {
    localStorage.setItem(`connected_users`, users.length.toString());
  }, [users]);

  function addConnectedUser(name: string) {
    setUsers((prev) => (prev.includes(name) ? prev : [...prev, name]));
  }

  // real-time socket updates for new logins
  useEffect(() => {
    const onQuizUserLogin = (data: { name?: string; presentationId?: string }) => {
      if (data?.presentationId && data.presentationId !== ppt._id) return;
      if (!data?.name) return;
      addConnectedUser(data.name);
      console.log('quiz-user-login', data);
    };

    client.on('quiz-user-login', onQuizUserLogin);
    return () => {
      client.off('quiz-user-login', onQuizUserLogin);
    };
  }, [client, ppt._id]);


  // update presentation quiz status
  const updateQuizStatus = async () => {
    await axios
        .post(
            `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/update-quiz-status`,
            {
              _id:ppt._id,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        ).then((res) => {
          console.log(res);
        });

  }
  // update user action and emit socket message using API
  function updateAction(jsonData:any) {
    console.log("updateAction >>> ",jsonData)
    console.log("updateAction >>> ",`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`)

    const headers = {
      'Content-Type': 'application/json',
    }

    axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`, jsonData, {
      headers: headers
    })
        .then((response) => {

          console.log("response", response)
        })
        .catch((error) => {
          console.log("error", error)
        })
  }



  return (

    <div className="quiz-home-page-container" style={{ minHeight: '100%' }}>
      <div className="quiz-home-header m-t-20">
        <Container fluid>
          <Row className='p-2' >
            <Col className="text-md-left text-center p-l-2" md={2} >  {event?.logo ?
              <img
                height={100}
                src={getEncodedImageUrl(event.logo, 90, 90, "contain")}
                alt="logo"
              /> : <img src="/images/logo-default.png" alt="logh" />
            }
            </Col>

            <Col className="text-center">
              <img className="m-t-10" height={140} src="/images/tutorial-1.svg" alt="quiz" />
              <h4 className="quiz-home-title">Quiz</h4>
            </Col>

            <Col className="text-md-right p-t-30" md={2} ><h5 style={{ textAlign: 'center' }}>{ppt.name}</h5>
            </Col>

          </Row>
        </Container>
      </div>
      <div className="quiz-home-body ">
        <Container>
          <Row>
            <Col lg={10} xl={8} md={12} className="mx-auto text-center">
              <p className="quiz-body-text">

                {intl.formatMessage({id: 'quiz.link.msg'})}<br />
              </p>
              <p className="quiz-body-text"><span>{`${process.env.REACT_APP_QUIZ}/${eventContext.slug}/${code}`}</span></p>

              <div className={`mb-5`}>
                <QRCode value={`${process.env.REACT_APP_QUIZ}/${eventContext.slug}/${code}`} style={{ height: "auto", maxWidth: "100px", width: "100px" }}/>


              </div>
{/*
              <p>  {intl.formatMessage({id: 'quiz.code.msg'})} <br />  <span className="quiz-code">{code}</span></p>*/}
            </Col>
          </Row>
        </Container>
      </div>

      <div className="conntected-users-container">
        <div className="conntected-users-count">
          <div className="count-header">

            <span>{users.length} {intl.formatMessage({id: 'quiz.connected'})}</span>

          </div>
        </div>
        <div className="list-of-connected-users">
          <ul>
            {/* display user list */}
            {users.map(value => {
              return (
                <li >{value}</li>
              )
            })}

          </ul>
        </div>
      </div>
      <div className={" quiz-hover text-center"} style={{paddingTop:'15px'}}><Link to={`/${eventContext.slug}/${ppt._id}/quiz-questions`}
                                                                                   onClick={() => {
                                                                                     // socket sent message to server
                                                                                     // SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:start_quiz"}`);
                                                                                     //
                                                                                     updateAction( {
                                                                                           presentationId: ppt._id,
                                                                                           action: "start_quiz",
                                                                                           question_index:0
                                                                                         }
                                                                                     );
                                                                                     updateQuizStatus();

                                                                                   }} className="btn btn-next">
        <b className="quiz-hover" style={{ color: '#24b2ff' }}>{intl.formatMessage({id:"quiz.start.quiz"})}</b>
      </Link></div>
      <Container fluid className={`mt-auto`}>
        <QuizFooter presentationId={ppt._id} screenMode={screenMode} />
      </Container>
    </div>
  )
}

export default QuizHome;
